/**
 * React Query 全局配置
 * 用于统一管理查询缓存策略
 * 
 * 修改记录：2026-02-09 - 预设数据实时更新功能
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,        // 2分钟后标记为过期
      cacheTime: 10 * 60 * 1000,       // 10分钟后清除缓存
      refetchOnWindowFocus: true,       // 窗口聚焦时重新获取
      refetchOnMount: true,             // 组件挂载时重新获取
      retry: 1,                         // 失败重试1次
    },
  },
});

